import { BaseApi, createBaseApiIsolated } from "../BaseApi";
import { InterceptToken } from "../../interceptors/TokenInterceptor";
import { TOKEN_TYPE } from "../../utils/Constant";

const consultarProcedimientosPssUrl =
  "api/v1/websalud/primeraars/prestadores/yo/procedimientos";

  const consultarProcedimientosPssIsoladoUrl =
  "api/v1/websalud/primeraars/prestadores/yo/procedimientosPss";

const getMedicosUrl = "api/v1/websalud/primeraars/prestadores/medicos";

const consultarTipoPssNoMedicoUrl =
  "api/v1/websalud/primeraars/prestadores/tipopssnomedico";

const actualizarCorreoPrestadorUrl =
  "api/v1/websalud/primeraars/prestadores/yo/correo";

const consultarProcedimientosPss = (request) =>
  InterceptToken(BaseApi.get, consultarProcedimientosPssUrl, request).then(
    (response) => response.data
  );

const consultarProcedimientosPssWithTokenIsolated = (requestData, accessToken) => {
  const headers = {
    Accept: "application/json",
    "Content-Type": "application/json",
    apikey: process.env.REACT_APP_API_KEY,
    Company: process.env.REACT_APP_COMPANY,
    Authorization: `${TOKEN_TYPE.BEARER} ${accessToken}`,
    "user_key": process.env.REACT_APP_API_KEY,
  };

  const isolatedApi = createBaseApiIsolated({ headers });

  return isolatedApi.get(consultarProcedimientosPssIsoladoUrl, requestData).then((response) => response.data);
};

const getMedicos = (request) =>
  InterceptToken(BaseApi.get, getMedicosUrl, request).then(
    (response) => response.data
  );

const consultarTipoPssNoMedico = (request) => {
  const headers = {
    Accept: "application/json",
    "Content-Type": "application/json",
    apikey: process.env.REACT_APP_API_KEY,
    Company: process.env.REACT_APP_COMPANY,
    "user_key": process.env.REACT_APP_API_KEY,
  };

  if (request?.requestHeaders?.Authorization) {
    headers.Authorization = request.requestHeaders.Authorization;
  }

  const isolatedApi = createBaseApiIsolated({ headers, withCredentials: false });

  return isolatedApi.get(consultarTipoPssNoMedicoUrl, request?.requestData || request).then((response) => response.data);
};

const actualizarCorreoPrestador = (request) =>
  InterceptToken(
    BaseApi.put,
    actualizarCorreoPrestadorUrl,
    request?.requestData,
    request.requestHeaders
  ).then((response) => response.data);

const exportedObject = {
  consultarProcedimientosPss,
  consultarProcedimientosPssWithTokenIsolated,
  getMedicos,
  consultarTipoPssNoMedico,
  actualizarCorreoPrestador,
};

export default exportedObject;
